import request from '@/utils/request'
import qs from 'qs'
const proxyUrl = process.env.Communityapi;
//圈子首页
export const selectCircleData = (data) => {
	return request({
		//headers: {'Content-Type':'application/json','Accept': 'application/json'},
		method: 'post',
		url:proxyUrl+'/circle/selectCircle/page',
		data:qs.stringify(data),
	})
};


// WEBPACK FOOTER //
// ./src/utils/api/communityCircle.js